import React from "react"
import { Link } from "react-router-dom"

import { localizer } from "../../../../Translator.js";

import { Grid, Container } from "@material-ui/core"
import { Backdrop, CircularProgress } from "@material-ui/core"
import Tooltip from '@material-ui/core/Tooltip'
import Typography from '@material-ui/core/Typography'
import { Button } from "@material-ui/core"
import Timeline from '@material-ui/lab/Timeline';
import TimelineSeparator from '@material-ui/lab/TimelineSeparator'
import TimelineConnector from '@material-ui/lab/TimelineConnector'
import TimelineContent from '@material-ui/lab/TimelineContent'
import TimelineDot from '@material-ui/lab/TimelineDot'
import IconButton from '@material-ui/core/IconButton'

import { TimelineItemStyled } from "../../../common/TimelineStyled.js"

import DateCustom from "../../../Utilities/DateCustom.js"
import { MultiShipmentImageViewer } from "../../../Utilities/MultiShipmentImageViewer.js"
import Roles from "../../../Utilities/Roles.js"

import InboxCli from "../../../../sdk/InboxCli.js"
import OutboxCli from "../../../../sdk/OutboxCli.js"
import CycleCli from "../../../../sdk/CycleCli.js"
import AuthCli from "../../../../sdk/AuthCli.js"
import ProductCli from "../../../../sdk/ProductCli.js"



export class OutboxShipmentSummary extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      isLoading: false,
      // Attributes to determinate when a draft is loaded in loadeddialog component.
      isLoadingDraft: false,
      
      // Shipment object which feedback belong to
      shipment: {},
      shipmentId: null,

      // List of products availables for the user in session
      products: [],

      // Concatenation of the names of the draft documents that make up the final document of the shipment
      documentNames: "",
      shipmentFeedbacks: [],

      // String errors to display in case of service calls go wrong
      feedbackShipmentError: null,
      feedbackShipmentDraftError: null,
      feedbackShipmentStatestError: null,
      downloadShipmentDocumentError: null,

     
      // Number of the current page which is displaying and pages in documents
      currentPage: 1,
      documentpages: [],

      // Base64 string that represent the content of draft document
      pageBase64: "",

      // String errors to display in case of service calls go wrong
      pageBase64Error: null,

      states: [],
      certs: [],
      proofs: [],
      reports: [],

      // Value of the price with format 
      priceFormat: "",

      //assigned codes
      trackingsDispatches: [],
      trackingMain: {}

    }
  }

  /**
   * Component initialization. Filling state with the shipment and its associate information (drafts, feedbacks, etc)
   */
  componentDidMount() {
    AuthCli.GetSessionInfo().then(session => {
      if (session) {
        this.setState({ session: session }, () => {
          this.getAvailableProductsForUser()

          if (this.state.session.role === Roles.ROLE_USER.Name) {
            this.getShipmentByCode(this.props.shipmentCode)
            return
          }

          if (this.state.session.role === Roles.ROLE_ADMIN.Name || this.state.session.role === Roles.ROLE_SUPERVISOR.Name) {
            this.getShipmentByCodeOfBillable(this.props.shipmentCode)
            return
          }
        })
      }
    })
  }

  // Getting list of product to visualize product description instead of productCode
  getAvailableProductsForUser = () => {
    ProductCli.GetAvailableProductsForUser().then(response => {
      if (response !== null && response.toString().startsWith("[ERR")) {
        this.setState({ errormessage: response.substring(response.indexOf(' ')) })
      } else {
        this.setState({ products: response })
      }
    })
  }

  getShipmentByCode = (shipmentCode) => {
    this.setState({ isLoading: true })
    OutboxCli.GetShipmentByCode(shipmentCode).then(data => {
      if (data !== null && data.toString().startsWith("[ERR")) {
        this.setState({ feedbackShipmentError: data.substring(data.indexOf(' ')) })
      } else {
        this.setState({ shipment: data, feedbackShipmentError: null },
          () => {
            this.setState({ documentpages: this.state.shipment.pages, shipmentId: this.state.shipment.shipmentId })
            this.getDocumentsOfShipment()
            this.getFeedbacksOfShipment()

            var priceFormat = ""
            if (data.features) {
              priceFormat = (data.features.price / 100).toLocaleString("es-ES", { style: "currency", currency: "EUR" });
            }
            this.setState({ priceFormat: priceFormat })
          })
      }
      this.setState({ isLoading: false })
    })
  }

  getShipmentByCodeOfBillable = (shipmentCode) => {
    this.setState({ isLoading: true })
    OutboxCli.GetShipmentByCodeOfBillable(shipmentCode).then(data => {
      if (data !== null && data.toString().startsWith("[ERR")) {
        this.setState({ feedbackShipmentError: data.substring(data.indexOf(' ')) })
      } else {
        this.setState({ shipment: data, feedbackShipmentError: null },
          () => {
            this.setState({ documentpages: this.state.shipment.pages, shipmentId: this.state.shipment.shipmentId })
            this.getDocumentsOfShipment()
            this.getFeedbacksOfShipment()
            this.getTrackingsOfShipment()

            var priceFormat = ""
            if (data.features) {
              priceFormat = (data.features.price / 100).toLocaleString("es-ES", { style: "currency", currency: "EUR" });
            }
            this.setState({ priceFormat: priceFormat })
          })
      }
      this.setState({ isLoading: false })
    })
  }
  
  /**
   * Gets assigned codes of the shipment given
   */
  getTrackingsOfShipment = () => {
    let shipmentcodes = [this.state.shipment.shipmentCode]
    CycleCli.GetAssignedCodes(shipmentcodes).then(response => {
      if (response !== null && response.toString().startsWith("[ERR")) {
        this.setState({ shipmentsError: response.substring(response.indexOf(' ')) })
      } else {
        let trackings = response.filter(t => t.codeType === 'CODE_TRACKING')
        trackings = trackings.sort(this.sortByDate)
        let trackingMain = trackings[0]
        let trackingsDispatches = []
        trackings.forEach((t, index) => {
          if (index !== 0) trackingsDispatches.push(t)
        });
        this.setState({ trackingMain: trackingMain, trackingsDispatches: trackingsDispatches })
      }
    })
  }
  
  /**
   * Gets feedbacks information of the shipment given
   */
  getFeedbacksOfShipment = () => {
    InboxCli.GetFeedbackOfShipment(this.state.shipment.shipmentCode, true, true, true, true, true).then(data => {
      if (data !== null && data.toString().startsWith("[ERR")) {
        this.setState({ feedbackShipmentStatestError: data.substring(data.indexOf(' ')) })
      } else {
        this.setState({ feedbackShipmentStatestError: null, shipmentFeedbacks: data },
          () => {
            this.getStatesInfo()
            this.getCertsInfo()
          })
      }
    })
  }

  /**
   * Gets states information of shipment to display it in the summary
   */
  getStatesInfo = () => {

    var returnsId = this.state.shipmentFeedbacks.filter(f => f.returnType === 'STATE').map(f => f.returnId)

    InboxCli.GetStates(returnsId).then(data => {
      if (data !== null && data.toString().startsWith("[ERR")) {
        this.setState({ feedbackShipmentStatestError: data.substring(data.indexOf(' ')) })
      } else {
        data = data.map(st => {
          var temp
          if (st !== null) {
            temp = Object.assign({}, st)
            temp.stateData = JSON.parse(st.stateData)
          }
          return temp
        })
        this.setState({ states: data })
      }
    })
  }

  /**
 * Gets certs information of shipment to display it in the summary
 */
  getCertsInfo = () => {
    var returnsId = this.state.shipmentFeedbacks.filter(f => f.returnType === 'CERT').map(f => f.returnId)

    InboxCli.GetCerts(returnsId).then(data => {
      if (data !== null && data.toString().startsWith("[ERR")) {
        this.setState({ feedbackShipmentStatestError: data.substring(data.indexOf(' ')) })
      } else {
        this.setState({ certs: data, feedbackShipmentStatestError: null })
      }
    })
  }


  downloadShipmentDocument = () => {
    this.setState({ isLoading: true })
    OutboxCli.DownloadShipmentDocument(this.state.shipment.shipmentCode).then((error) => {
      this.setState({ isLoading: false })
      if (error) this.setState({ downloadShipmentDocumentError: error.substring(error.indexOf(' ')) })
      else this.setState({ downloadShipmentDocumentError: null })
    })
  }

  handleisLoadingDraft = () => {
    this.setState({ isLoadingDraft: false })
  }

  mountDestinationAddress = () => {
    if (!this.state.shipment) return ""
    if (!this.state.shipment.destinationAddress) return ""
    
    let destinationaddress = this.state.shipment.destinationAddress.who + "\n" +
      this.state.shipment.destinationAddress.streetType + " " + this.state.shipment.destinationAddress.streetName + " " + this.state.shipment.destinationAddress.streetNumber + " " + this.state.shipment.destinationAddress.streetComplements + "\n" +
      this.state.shipment.destinationAddress.postalCode + " " + this.state.shipment.destinationAddress.locality
    return destinationaddress
  }

  mountSenderAddress = () => {
    if (!this.state.shipment) return ""
    if (!this.state.shipment.senderAddress) return ""
    
    let senderAddress = this.state.shipment.senderAddress.who + "\n" +
      this.state.shipment.senderAddress.streetType + " " + this.state.shipment.senderAddress.streetName + " " + this.state.shipment.senderAddress.streetNumber + " " + this.state.shipment.senderAddress.streetComplements + "\n" +
      this.state.shipment.senderAddress.postalCode + " " + this.state.shipment.senderAddress.locality
    return senderAddress
  }

  /**
   * get url to logistic operator
   */
  getUrlOperator = (tracking) => {
    if (!tracking) return ''
    let products = ["PQ", "PK", "NB", "CD", ...ProductCli.SIDI_PRODUCT_CODE];
    let codTracking = tracking.codeValue
    let initTracking = codTracking && codTracking.slice(0, 2);
    const url = products.includes(initTracking) ?
      'https://www.correos.es/es/es/herramientas/localizador/envios/detalle?tracking-number=' + codTracking : ''
    return url
  }

  getProductDescription = () => {
    let description = ""
    this.state.products && this.state.shipment.features && this.state.products.forEach(product => {
      if (product.productCode === this.state.shipment.features.productCode) {
        description = product.description
        return
      }
    })
    return description
  }

  /**
  * Get documents and pages information to display the preview in the shipment summary for role USER
  */
  getDocumentsOfShipment = () => {
    var documentNames = []
    this.state.shipment.pages.map(page => {
      return (OutboxCli.GetDraft(page.draftId).then(data => {
        if (data !== null && data.toString().startsWith("[ERR")) {
          this.setState({ feedbackShipmentDraftError: data.substring(data.indexOf(' ')) })
        } else {
          documentNames.push(data.documentName + " (" + (page.pageFirst !== page.pageLast ? (page.pageFirst + " - " + page.pageLast) : page.pageFirst) + ")")
          // documentNames += data.documentName + " (" + (page.pageFirst !== page.pageLast ? (page.pageFirst + " - " + page.pageLast) : page.pageFirst) + ")\n"
          this.setState({ feedbackShipmentDraftError: null, documentNames: documentNames })
        }
      })
      )
    })
  }

  /**
   * Get documents and pages information to display the preview in the shipment summary for role ADMIN
   */
  getDocumentsOfShipmentOfBillable = () => {
    var documentNames = []
    this.state.shipment.pages.map(page => {
      return (OutboxCli.GetDraftOfBillable(page.draftId).then(data => {
        if (data !== null && data.toString().startsWith("[ERR")) {
          this.setState({ feedbackShipmentDraftError: data.substring(data.indexOf(' ')) })
        } else {
          documentNames.push(data.documentName + " (" + (page.pageFirst !== page.pageLast ? (page.pageFirst + " - " + page.pageLast) : page.pageFirst) + ")")
          // documentNames += data.documentName + " (" + (page.pageFirst !== page.pageLast ? (page.pageFirst + " - " + page.pageLast) : page.pageFirst) + ")\n"
          this.setState({ feedbackShipmentDraftError: null, documentNames: documentNames })
        }
      })
      )
    })
  }


  render() {
    let url = this.getUrlOperator(this.state.trackingMain)

    return (

      <React.Fragment>
        <Container className="pl-18 pr-18 pb-12 pt-55">
          <Grid container item md={12} style={{ marginTop: '20px' }} justify="center">
            <Typography className="typography-generic xlarge medium-weight">{this.state.shipment.features ? this.state.shipment.features.reference.toUpperCase() : ""}</Typography>
          </Grid>
          <Grid container item md={12} style={{ marginTop: '10px' }} justify="center">
            <Typography className="typography-generic large bigweight">{localizer.InboxShipmentDetails + ": " + this.state.shipment.shipmentCode}</Typography>
            {this.state.trackingMain &&
              <Typography className="typography-generic large bigweight"> - {localizer.Tracking}: {this.state.trackingMain.codeValue}</Typography>
            }
          </Grid>
          <Grid container direction="row" spacing={4} style={{ marginTop: '20px' }}>
            <Grid item md={4} style={{ borderRight: '1px solid' }}>
              <Grid container item md={12} style={{ marginTop: '10px' }}>
                <Typography className="typography-generic medium bigweight secondary">{localizer.InboxChronology}</Typography>
              </Grid>
              <hr className="hr-custom"></hr>
              <Grid container item md={12} style={{ marginTop: '20px' }}>
                <Grid item md={6}><Typography className="typography-generic  bigweight ml-42">{localizer.InboxDateHour}</Typography></Grid>
                <Grid item md={6}><Typography className="typography-generic  bigweight">{localizer.InboxEvent}</Typography></Grid>
              </Grid>
              <Grid container item md={12} style={{ marginTop: '20px' }}>
                <Timeline>
                  {this.state.states && this.state.states.map((state, index) => {
                    return (
                      <TimelineItemStyled key={state.returnId}>
                        <TimelineSeparator>
                          <TimelineDot style={{ backgroundColor: '#47A6D6' }} />
                          <TimelineConnector style={index !== this.state.states.length - 1 ? { backgroundColor: '#47A6D6' } : { backgroundColor: '' }} />
                        </TimelineSeparator>
                        <TimelineContent>
                          <Grid container item md={12}>
                            <Grid item md={6}><Typography className="typography-generic  bigweight">{DateCustom.convertUTCToLocalTime(state.timestamp)}</Typography></Grid>
                            <Grid item md={6}>
                              <Typography className="typography-generic  bigweight">{state.stateData.Description}</Typography>
                              <Grid item md={12} style={{ display: 'inline-flex' }}>
                                <Grid item md={6}><Typography className="typography-generic  bigweight pt-0" >Office:</Typography></Grid>
                                <Grid item md={6}><Typography className="typography-generic  bigweight pt-0">{state.stateData.Office}</Typography></Grid>
                              </Grid>
                            </Grid>
                          </Grid>
                        </TimelineContent>
                      </TimelineItemStyled>
                    )
                  })}
                </Timeline>
              </Grid>
              {this.state.trackingMain &&
                <Grid container direction="row" className="mt-15 mr-20">
                  <Grid item md={12} >
                    <Grid item md={12}>
                      <Typography className="typography-generic bigweight secondary"> {localizer.Tracking}: </Typography></Grid>
                  </Grid>
                  <Grid container item md={12} className="mr-20">
                    <Grid item md={6}><Typography className="typography-generic pb-0 pt-0">{DateCustom.convertUTCToLocalTime(this.state.trackingMain.assignedTime)}</Typography></Grid>
                    <Grid item md={6}><Typography className="typography-generic bigweight  pb-0 pt-0"><a href={url} className="link-hover" target="_blank" rel="noreferrer">{this.state.trackingMain.codeValue}</a></Typography></Grid>
                  </Grid>
                </Grid>
  
              }

              {this.state.trackingsDispatches && this.state.trackingsDispatches.length !== 0 &&
                <Grid container item md={12} className="mt-20">
                  <Grid item md={12}>
                    <Typography className="typography-generic bigweight secondary"> {localizer.ReDispatches}: </Typography>
                    <hr className="hr-custom" />
                  </Grid>
                  {this.state.trackingsDispatches.map(t => {
                    let url = this.getUrlOperator(t)
                    return (
                      <Grid container item md={12}>
                        <Grid item md={6}><Typography className="typography-generic">{DateCustom.convertUTCToLocalTime(t.assignedTime)}</Typography></Grid>
                        <Grid item md={6}><Typography className="typography-generic bigweight"><a href={url} className="link-hover" target="_blank" rel="noreferrer">{t.codeValue}</a></Typography></Grid>
                      </Grid>
                    )
                  })
                  }
                  {/* <Button style={{ width: "auto" }} className="button-generic primary" variant="outlined" startIcon={<LocationOnIcon />}>
                    {localizer.PostalOperator}
                  </Button> */}
                </Grid>
              }
            </Grid>

            <Grid item md={4} style={{ borderRight: '1px solid' }}>
              <Grid container item md={12} style={{ marginTop: '10px' }}>
                <Typography className="typography-generic medium bigweight secondary">{localizer.InboxShipmentInfo}</Typography>
              </Grid>
              <hr className="hr-custom"></hr>
              <Grid container item md={12} style={{ marginTop: '20px' }}>
                <Grid item md={5}><Typography className="typography-generic medium-weight">{localizer.InboxShipmentType}:</Typography></Grid>
                <Grid item md={7}><Typography className="typography-generic bigweight">{this.getProductDescription()}</Typography></Grid>
              </Grid>
              <Grid container item md={12} style={{ marginTop: '20px' }}>
                <Grid item md={5}><Typography className="typography-generic medium-weight">{localizer.InboxIncludedPages}:</Typography></Grid>
                <Grid item md={7}>
                  {this.state.documentNames && this.state.documentNames.map((doc, index) => {
                    return (<Typography key={"docname-" + index} className="typography-generic shipment-summary-docnames p-0">{doc}</Typography>)
                  })}
                </Grid>
              </Grid>
              <Grid container item md={12} style={{ marginTop: '20px' }}>
                <Grid item md={5}><Typography className="typography-generic medium-weight">{localizer.InboxSender}:</Typography></Grid>
                <Grid item md={7}>
                  <Typography className="typography-generic bigweight white-space-pre p-0">{this.mountSenderAddress()}</Typography>
                </Grid>
              </Grid>
              <Grid container item md={12} style={{ marginTop: '20px' }}>
                <Grid item md={5}><Typography className="typography-generic medium-weight">{localizer.InboxDestination}:</Typography></Grid>
                <Grid item md={7}>
                  <Typography className="typography-generic bigweight white-space-pre p-0">{this.mountDestinationAddress()}</Typography>
                </Grid>
              </Grid>
              <Grid container item md={12} style={{ marginTop: '20px' }}>
                <Grid item md={5}><Typography className="typography-generic medium-weight">{localizer.InboxPrintFeatures}:</Typography></Grid>
                <Grid item md={7}><Typography className="typography-generic bigweight">{this.state.shipment.features ? (this.state.shipment.features.printColor ? "Color" : "B/N") + ", " + (this.state.shipment.features.printDuplex ? localizer.InboxDuplex : localizer.InboxSimplex) : ""}</Typography></Grid>
              </Grid>
              <Grid container item md={12} style={{ marginTop: '20px' }}>
                <Grid item md={5}><Typography className="typography-generic medium-weight">{localizer.InboxPrice}:</Typography></Grid>
                <Grid item md={7}><Typography className="typography-generic bigweight">{this.state.priceFormat} + {localizer.ShippingEstimatedCostVat}</Typography></Grid>
              </Grid>
              <br></br>
              <br></br>
              <Grid container item md={12} style={{ marginTop: '10px' }}>
                <Typography className="typography-generic medium bigweight secondary">{localizer.InboxCetificates}</Typography>
              </Grid>
              <hr className="hr-custom"></hr>
              {this.state.certs && this.state.certs.map((cert, index) => {
                return (
                  <Grid key={cert.returnId + "-" + index} container item md={12} spacing={2}>
                    <Grid item md={4}><Typography className="typography-generic medium-weight">{DateCustom.formatDate(cert.timestamp)}</Typography></Grid>
                    <Grid item md={6} title={cert.documentFileName}><Typography className="typography-generic textinline bigweight">{cert.documentFileName}</Typography></Grid>
                    <Grid item md={2} className="text-align-right">
                      <Tooltip className="typography-generic" title={<Typography className="typography-generic">{localizer.Download}</Typography>}>
                        <IconButton className="button-generic icon-button mt-5neg" aria-label="download" onClick={this.downloadCert}><i className="fa-solid fa-file-arrow-down font-size-20"></i></IconButton>
                      </Tooltip>
                    </Grid>
                  </Grid>
                )
              })}
            </Grid>

            <Grid item md={4}>
              <Grid container item md={12} className="m-0">
                <Grid container item justify="flex-start" md={6} alignItems="center">
                  <Typography className="typography-generic medium bigweight secondary">{localizer.InboxPreview}</Typography>
                </Grid>
                <Grid container item justify="flex-end" md={6} alignItems="center">
                  <Button className="button-generic primary mb-10" variant="contained" onClick={this.downloadShipmentDocument} startIcon={<i className="fa-solid fa-file-arrow-down"></i>}>
                    {localizer.Download}
                  </Button>
                </Grid>
              </Grid>
              <hr className="hr-custom"></hr>
              <Grid container item md={12} className="p-2pc border-radius-20 mb-2_5pc mt-2_5pc">
                <MultiShipmentImageViewer
                  shipmentId={this.state.shipmentId}
                  documentpages={this.state.documentpages}
                  pagenumber={this.state.currentPage}
                  viewerWidth={350}
                  viewerHeight={500}
                  handleisLoadingDraft={this.handleisLoadingDraft}
                />
                {/*   <Grid item md={12} style={{ textAlign: 'center' }}>
                  <Tooltip title={<Typography className="typography-generic">{localizer.Download}</Typography>}>
                    <IconButton className="button-generic icon-button mt-5neg" aria-label="download" onClick={this.downloadShipmentDocument} ><i className="fa-solid fa-file-arrow-down"></i></IconButton>
                  </Tooltip>               
               
                </Grid> */}
              </Grid>
            </Grid>
          </Grid>
          {/* Step buttons */}
          <Grid container spacing={4} direction="row" justify="center" alignItems="center" style={{ textAlign: "center", paddingTop: 100 }}>
            <Button className="button-generic secondary" variant="contained" name="previous" component={Link} to="/outbox">{localizer.Previous}</Button>
          </Grid>
        </Container>
        {/* Waiting for service response. */}
        {this.state.isLoadingDraft &&
          <Backdrop open={this.state.isLoadingDraft} style={{ zIndex: 1350 }}>
            <CircularProgress color="secondary" />
          </Backdrop>
        }
      </React.Fragment>
    )
  }
}

export default OutboxShipmentSummary


// WEBPACK FOOTER //
// ./src/components/shipments/sections/summary/OutboxShipmentSummary.js